import * as HoverCard from '@radix-ui/react-hover-card';
import type { JSX, ReactNode } from 'react';

import './ExamineHover.less';

interface ExamineHoverProps {
  children: ReactNode;
  content: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export const ExamineHover = ({ children, content, side = 'top' }: ExamineHoverProps): JSX.Element => {
  return (
    <HoverCard.Root openDelay={0} closeDelay={0}>
      <HoverCard.Trigger asChild>{children}</HoverCard.Trigger>
      <HoverCard.Portal>
        <HoverCard.Content className="examine-hover-content" side={side} sideOffset={25}>
          {content}
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
};
